import {
  AccountingAwardDto,
  FinalSettlementDto,
  FinalSettlementPositiveDto,
  FinalSettlementNegativeDto,
  DefinitiveWarrantyRefundDto,
  PaymentDTO,
  FirstPaymentDTO,
  SecondPaymentDTO
} from '.'
import { Accounting } from '@/Domain/Expediente'

export class AccountingDto {
  private _accountingAward: AccountingAwardDto | null
  private _finalSettlement: FinalSettlementDto | null
  private _positiveFinalSettlement: FinalSettlementPositiveDto | null
  private _negativeFinalSettlement: FinalSettlementNegativeDto | null
  private _definitiveWarrantyRefund: DefinitiveWarrantyRefundDto | null
  private _payment: PaymentDTO | null
  private _firstPayment: FirstPaymentDTO | null
  private _secondPayment : SecondPaymentDTO | null
  private _fraccionaPago : boolean
  private _danos : boolean

  static fromAccounting (account: Accounting): AccountingDto {
    const award = account.award
    let awardDto = null
    if (award !== null) { awardDto = AccountingAwardDto.fromAccounting(award) }

    const final = account.finalSettlement
    let finalDto = null
    if (final !== null) { finalDto = FinalSettlementDto.fromFinal(final) }

    const posi = account.positiveFinalSettlement
    let posiDto = null
    if (posi !== null) { posiDto = FinalSettlementPositiveDto.fromFinal(posi) }

    const nega = account.negativeFinalSettlement
    let negaDto = null
    if (nega !== null) { negaDto = FinalSettlementNegativeDto.fromFinal(nega) }

    const defi = account.definitiveWarrantyRefund
    let defiDto = null
    if (defi !== null) { defiDto = DefinitiveWarrantyRefundDto.fromDefinitive(defi) }

    const pay = account.payment
    let paydto = null
    if (pay !== null) { paydto = PaymentDTO.fromPayment(pay) }

    const firstpay = account.firstPayment
    let firstpaydto = null
    if (firstpay !== null) { firstpaydto = FirstPaymentDTO.fromFirstPayment(firstpay) }

    const secondpay = account.secondPayment
    let secondpaydto = null
    if (secondpay !== null) { secondpaydto = SecondPaymentDTO.fromSecondPayment(secondpay) }

    return new AccountingDto(
      awardDto,
      finalDto,
      posiDto,
      negaDto,
      defiDto,
      paydto,
      firstpaydto,
      secondpaydto,
      account.fraccionaPago,
      account.danos
    )
  }

  constructor (
    accountingAward: AccountingAwardDto | null,
    finalSettlement: FinalSettlementDto | null,
    positiveFinalSettlement: FinalSettlementPositiveDto | null,
    negativeFinalSettlement: FinalSettlementNegativeDto | null,
    definitiveWarrantyRefund: DefinitiveWarrantyRefundDto | null,
    payment: PaymentDTO | null,
    firstPayment: FirstPaymentDTO | null,
    secondPayment: SecondPaymentDTO | null,
    fraccionaPago: boolean,
    danos: boolean
  ) {
    this._accountingAward = accountingAward
    this._finalSettlement = finalSettlement
    this._positiveFinalSettlement = positiveFinalSettlement
    this._negativeFinalSettlement = negativeFinalSettlement
    this._definitiveWarrantyRefund = definitiveWarrantyRefund
    this._payment = payment
    this._firstPayment = firstPayment
    this._secondPayment = secondPayment
    this._fraccionaPago = fraccionaPago
    this._danos = danos
  }

  get award (): AccountingAwardDto | null {
    return this._accountingAward
  }

  public setAward (award: AccountingAwardDto): void {
    this._accountingAward = award
  }

  get finalSettlement (): FinalSettlementDto | null {
    return this._finalSettlement
  }

  public setFinalSettlement (finalSettlement: FinalSettlementDto): void {
    this._finalSettlement = finalSettlement
  }

  get positiveFinalSettlement (): FinalSettlementPositiveDto | null {
    return this._positiveFinalSettlement
  }

  public setPositiveFinalSettlement (positiveFinalSettlement: FinalSettlementPositiveDto): void {
    this._positiveFinalSettlement = positiveFinalSettlement
  }

  get negativeFinalSettlement (): FinalSettlementNegativeDto | null {
    return this._negativeFinalSettlement
  }

  public setNegativeFinalSettlement (negativeFinalSettlement: FinalSettlementNegativeDto): void {
    this._negativeFinalSettlement = negativeFinalSettlement
  }

  get definitiveWarrantyRefund (): DefinitiveWarrantyRefundDto | null {
    return this._definitiveWarrantyRefund
  }

  public setDefinitiveWarrantyRefund (definitiveWarrantyRefund: DefinitiveWarrantyRefundDto): void {
    this._definitiveWarrantyRefund = definitiveWarrantyRefund
  }

  get payment (): PaymentDTO | null {
    return this._payment
  }

  public setPayment (payment: PaymentDTO): void {
    this._payment = payment
  }

  get firstPayment (): FirstPaymentDTO | null {
    return this._firstPayment
  }

  public setFirstPayment (firstPayment: FirstPaymentDTO): void {
    this._firstPayment = firstPayment
  }

  get secondPayment (): SecondPaymentDTO | null {
    return this._secondPayment
  }

  get fraccionaPago (): boolean {
    return this._fraccionaPago
  }

  get danos (): boolean {
    return this._danos
  }

  public setSecondPayment (secondPayment: SecondPaymentDTO): void {
    this._secondPayment = secondPayment
  }
}
